import { remove } from 'lodash';
import DeviceService from '@/modules/core/ui/services/DeviceService';
import NavResource from '@/modules/core/nav/resources/NavResource';
import { commits } from '@/modules/core/app/helpers/store';
import { NavKey } from '@/modules/core/nav/constants/NavKey';
import { NavItem } from '@/modules/core/nav/models/NavItem';

export class NavService {
  async getNavItems(params: Params = {}): Promise<NavItem[]> {
    const items: NavItem[] = await NavResource.getNav(params);

    if (!DeviceService.isMobile()) {
      const footerItems: NavItem[] = remove(items, (item: NavItem) =>
        NavKey.getFooterItemKeys().includes(item.key)
      );
      commits.nav.setFooterNavItems(footerItems);

      const headerItems: NavItem[] = remove(items, (item: NavItem) =>
        NavKey.getHeaderItemKeys().includes(item.key)
      );
      commits.nav.setHeaderNavItems(headerItems);
    }

    commits.nav.setNavItems(items);

    return items;
  }
}

export default new NavService();
